var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SecondaryText, Title } from "../../designSystem";
import colors from "../../designSystem/colors";
import useLoadingText from "../../hooks/useLoadingText";
import { getAssetDisplay } from "../../utils/asset";
import { formatAmount } from "../../utils/math";
import ProgressBar from "./ProgressBar";
var CapBar = function (_a) {
    var loading = _a.loading, current = _a.current, cap = _a.cap, _b = _a.copies, copies = _b === void 0 ? { current: "Total Deposits", cap: "Limit" } : _b, _c = _a.displayData, _d = _c === void 0 ? {} : _c, displayCurrent = _d.current, displayCap = _d.cap, _e = _a.labelConfig, labelConfig = _e === void 0 ? { fontSize: 16 } : _e, _f = _a.statsConfig, statsConfig = _f === void 0 ? { fontSize: 16 } : _f, _g = _a.barConfig, barConfig = _g === void 0 ? { height: 16, extraClassNames: "my-3", radius: 4 } : _g, asset = _a.asset;
    var loadingText = useLoadingText();
    var percent = cap > 0 ? current / cap : 0;
    if (percent < 0) {
        percent = 0;
    }
    else if (percent > 1) {
        percent = 1;
    }
    percent *= 100;
    current = current > cap ? cap : current;
    return (_jsxs("div", __assign({ className: "w-100" }, { children: [_jsxs("div", __assign({ className: "d-flex flex-row justify-content-between" }, { children: [_jsx(SecondaryText, __assign({ color: colors.tertiaryText, fontSize: labelConfig.fontSize }, { children: copies.current }), void 0), _jsx(Title, __assign({ fontSize: statsConfig.fontSize, lineHeight: 20 }, { children: loading
                            ? loadingText
                            : "" + (displayCurrent
                                ? displayCurrent
                                : formatAmount(current) + " " + (asset ? getAssetDisplay(asset) : "")) }), void 0)] }), void 0), _jsx(ProgressBar, { percent: percent, config: barConfig }, void 0), _jsxs("div", __assign({ className: "d-flex flex-row justify-content-between" }, { children: [_jsx(SecondaryText, __assign({ color: colors.tertiaryText, fontSize: labelConfig.fontSize }, { children: copies.cap }), void 0), _jsx(Title, __assign({ fontSize: statsConfig.fontSize, lineHeight: 20 }, { children: loading
                            ? loadingText
                            : "" + (displayCap
                                ? displayCap
                                : formatAmount(cap) + " " + (asset ? getAssetDisplay(asset) : "")) }), void 0)] }), void 0)] }), void 0));
};
export default CapBar;
//# sourceMappingURL=CapBar.js.map